<template lang="pug">
  .content
    .row.mt-5
      .col
        h4 {{message}}
    .row.mt-1
      .col.error {{error}}
    .row
    v-dialog(:click-to-close="false")
</template>

<script>
import AUTH_TOKEN from '../../graphql/AuthToken.gql'
import {AUTH_TOKEN_KEY, AUTH_USER_SHOP} from '../../tools'
import {Auth} from '../../helpers'

export default {
  name: 'ShopifyFinalize',
  props:{},
  data() {
    return {
        shopifyData: null,
        error: null,
        message: null
    }
  },
  mounted() {
      this.message = "Welcome on SmartSync!"
      this.shopifyData = this.$route.query
      
      this.$modal.show('dialog', {
        title: 'SETTING UP',
        text: 'We are setting up your account, it won\'t take long!',
      })
      
      if(this.validateShopifyData()){
          this.$modal.hide('dialog')
          this.logIn();
      } else {
          this.$modal.hide('dialog')
          this.error = "An error occoured during Shopify account validation. Please retry."
      }
  },
  methods: {
    validateShopifyData(){
        if(!this.shopifyData) return false;
        if(!this.shopifyData.code || !this.shopifyData.hmac || !this.shopifyData.shop || !this.shopifyData.state) return false;
        if(!this.checkNonce()) return false;
        return true;
    }, 
    checkNonce(){
      if(this.shopifyData.state != localStorage.getItem("authenticationNonce")) return false;
      return true;
    },
    logIn(){
        // Call API
        // Save userAuthToken
        // await onLogin(this.$apollo, token)
        console.log("qui dentro")
        this.$apollo.mutate({
          // Query
          mutation: AUTH_TOKEN,
          // Parameters
          variables: {
            authorizationCode: this.shopifyData.code,
            hmac: this.shopifyData.hmac,
            timestamp: this.shopifyData.timestamp,
            nonce: this.shopifyData.state,
            shop: this.shopifyData.shop
          }
        })
        .then(
          (response) => {
            const token = response.data.authToken.token
            this.message = "Logging you in..."
            localStorage.setItem(AUTH_TOKEN_KEY, token)
            localStorage.setItem(AUTH_USER_SHOP, response.data.authToken.payload.shopify_store_domain)
            // Let's log In user
            Auth.logInUser(token);
            this.message = "Successfully logged in! Go to homepage."
            window.location.href = "/"
          }, (error) => {
            console.log(error)
            this.error = "An error occoured during Shopify account validation. Please retry."  
          })
    }      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .error {
    color: rgb(88, 0, 0);
    font-weight: 600;
    font-size: 14px;
  }
</style>
